(function () {
  'use strict';

  var stateData = {
    MXAGU:{name:"Aguascalientes",ppm:210,level:"mid",badge:"Agua media",desc:"La dureza media puede empezar a dejar residuos en llaves y regaderas. Un sistema preventivo mantiene el hogar en mejor estado.",home:"En vivienda puede generar manchas, residuos en regaderas y más mantenimiento del boiler.",business:"En comercios pequeños y medianos puede aumentar limpieza y desgaste en equipos con agua caliente."},
    MXBCN:{name:"Baja California",ppm:250,level:"high",badge:"Agua dura",desc:"La dureza alta puede notarse en sarro visible. Un acondicionador mejora la operación diaria del hogar.",home:"En casa puede causar costras en regaderas, boiler y lavadora.",business:"En negocios eleva el mantenimiento de equipos y tuberías de agua caliente."},
    MXBCS:{name:"Baja California Sur",ppm:180,level:"mid",badge:"Agua media",desc:"El agua costera combina dureza media con cloruros. Un sistema dual sedimentos + dureza es la opción más completa.",home:"En hogares costeros puede dejar residuos y desgaste gradual en grifería y calentadores.",business:"En hoteles y renta vacacional conviene proteger duchas, boilers y lavadoras."},
    MXCAM:{name:"Campeche",ppm:290,level:"high",badge:"Agua dura",desc:"Zona calcárea con dureza alta. El sarro en regaderas, tuberías y boilers es común.",home:"En vivienda se nota en sarro duro y más limpieza en baño y cocina.",business:"En hoteles y cocinas puede elevar el costo de mantenimiento y consumo energético."},
    MXCHP:{name:"Chiapas",ppm:120,level:"low",badge:"Agua media",desc:"Con dureza baja, el sarro es menos problemático. Se recomienda enfocarse en sedimentos.",home:"En casa hay menos incrustaciones, pero conviene cuidar la filtración.",business:"En negocios el impacto por sarro es menor; conviene priorizar sedimentos y control sanitario."},
    MXCHH:{name:"Chihuahua",ppm:320,level:"extreme",badge:"Agua muy dura",desc:"Cuando la dureza es muy alta, el sarro se acumula rápido. Aquí conviene una solución robusta.",home:"En el hogar puede tapar llaves, manchar sanitarios y forzar calentadores.",business:"En negocios incrementa paros de mantenimiento y consumo energético."},
    MXCMX:{name:"Ciudad de México",ppm:165,level:"mid",badge:"Agua media",desc:"Un nivel medio de dureza puede generar manchas. Una solución doméstica mejora la experiencia de uso.",home:"Puede dejar residuos en grifería y la tina, y exigir limpieza frecuente.",business:"Puede elevar el costo de mantenimiento en cafeterías, oficinas y pequeños locales."},
    MXCOA:{name:"Coahuila",ppm:310,level:"extreme",badge:"Agua muy dura",desc:"Niveles muy altos de dureza requieren atacar el problema desde la entrada del agua.",home:"En casa puede generar sarro duro, menor eficiencia del boiler y desgaste de electrodomésticos.",business:"En empresas puede afectar líneas de agua, equipos térmicos y costos de operación."},
    MXCOL:{name:"Colima",ppm:175,level:"mid",badge:"Agua media",desc:"Dureza media con tendencia a manchas. Un filtro compacto en la entrada del hogar es suficiente.",home:"En vivienda se acumulan residuos ligeros en baño y cocina.",business:"En comercios el sarro puede notarse en lavavajillas y equipos de servicio."},
    MXDUR:{name:"Durango",ppm:230,level:"high",badge:"Agua dura",desc:"En zonas con dureza alta, el sarro en regaderas y electrodomésticos es común.",home:"Puede dejar costras en regaderas, llaves y boiler.",business:"En negocios eleva el mantenimiento de equipos y reduce eficiencia de operación."},
    MXGRO:{name:"Guerrero",ppm:140,level:"low",badge:"Agua media",desc:"Con dureza baja, se recomienda enfocarse en purificación de sedimentos y bacterias.",home:"En casa el problema principal no suele ser el sarro, sino la calidad general del agua.",business:"En negocios conviene priorizar filtración y control de sedimentos."},
    MXGUA:{name:"Guanajuato",ppm:285,level:"high",badge:"Agua dura",desc:"La dureza alta se traduce en manchas e incrustaciones. Una solución extiende la vida útil de los equipos.",home:"En vivienda puede aumentar el desgaste de boiler, lavadora y grifería.",business:"En negocios eleva el gasto de limpieza, desincrustado y mantenimiento preventivo."},
    MXHID:{name:"Hidalgo",ppm:260,level:"high",badge:"Agua dura",desc:"Dureza alta frecuente. Un sistema de acondicionamiento reduce sarro en boilers, lavadoras y regaderas.",home:"En el hogar puede provocar incrustaciones y menor presión en instalaciones.",business:"En negocios puede afectar equipos de agua caliente y procesos de limpieza."},
    MXJAL:{name:"Jalisco",ppm:280,level:"extreme",badge:"Agua muy dura",desc:"En Jalisco la dureza del agua es elevada y el sarro se acumula con rapidez en regaderas, tuberías y boilers. Un sistema de protección ayuda a reducir el mantenimiento y alargar la vida de los equipos.",home:"En casa puede aumentar el mantenimiento y dejar manchas visibles en grifería, regaderas y calentadores.",business:"En negocios incrementa la frecuencia de limpieza y la atención técnica a instalaciones con agua caliente."},
    MXMEX:{name:"Estado de México",ppm:195,level:"extreme",badge:"Agua muy dura",desc:"El Estado de México presenta niveles elevados de dureza en gran parte de su territorio, con formación de sarro y residuos en instalaciones. Una solución robusta protege tuberías y electrodomésticos.",home:"En vivienda puede variar por zona, pero suele dejar depósitos y exigir mayor limpieza en cocina y baño.",business:"En comercios puede elevar la carga de mantenimiento en líneas de agua caliente y grifería."},
    MXMIC:{name:"Michoacán",ppm:210,level:"mid",badge:"Agua media",desc:"La dureza media puede dejar residuos en llaves y regaderas. Un sistema preventivo es recomendable.",home:"En casa puede requerir más limpieza y cuidado de boiler.",business:"En negocios puede afectar lavados, cocinas y equipos de servicio."},
    MXMOR:{name:"Morelos",ppm:220,level:"mid",badge:"Agua media",desc:"Nivel medio de dureza que puede generar manchas. Un filtro estándar es suficiente preventivo.",home:"En el hogar puede dejar depósitos moderados y exigir limpieza continua.",business:"En negocios puede acumular sarro en baños, cocinas y regaderas."},
    MXNAY:{name:"Nayarit",ppm:155,level:"low",badge:"Agua media",desc:"Dureza baja en general. Se recomienda un filtro enfocado en sedimentos y mejora de sabor.",home:"En casa el sarro suele ser bajo, pero conviene cuidar la filtración.",business:"En negocios conviene priorizar sedimentos y limpieza del sistema."},
    MXNLE:{name:"Nuevo León",ppm:340,level:"extreme",badge:"Agua muy dura",desc:"Cuando la dureza es muy alta, el sarro se acumula rápido afectando todas las instalaciones.",home:"En el hogar puede dañar boiler, lavadora y regaderas con mayor rapidez.",business:"En negocios puede frenar equipos, aumentar mantenimiento y elevar costos."},
    MXOAX:{name:"Oaxaca",ppm:135,level:"low",badge:"Agua media",desc:"Con dureza baja, se recomienda enfocarse en sedimentos según la fuente de agua local.",home:"En casa el sarro suele ser menor, aunque puede variar por zona.",business:"En negocios conviene monitorear sedimentos y la calidad general del suministro."},
    MXPUE:{name:"Puebla",ppm:240,level:"high",badge:"Agua dura",desc:"La dureza alta causa incrustaciones visibles. Un sistema antisarro protege tuberías y calentadores.",home:"En vivienda genera depósitos en regaderas, cocina y boiler.",business:"En negocios aumenta limpieza y mantenimiento de líneas de agua."},
    MXQUE:{name:"Querétaro",ppm:295,level:"high",badge:"Agua dura",desc:"La dureza alta se traduce en manchas e incrustaciones. Una solución extiende la vida de los equipos.",home:"En casa puede afectar sanitarios, boiler y electrodomésticos.",business:"En negocios puede elevar costos operativos y desgaste de equipos."},
    MXROO:{name:"Quintana Roo",ppm:350,level:"extreme",badge:"Agua muy dura",desc:"Zona kárstica con dureza muy alta. Las incrustaciones afectan rápidamente calentadores y tuberías.",home:"En vivienda y hotelería puede generar sarro fuerte y mantenimiento constante.",business:"En negocios turísticos eleva el costo de operación y reduce eficiencia."},
    MXSLP:{name:"San Luis Potosí",ppm:270,level:"high",badge:"Agua dura",desc:"Dureza alta en gran parte del estado. Un sistema antisarro es indispensable para proteger instalaciones.",home:"En casa puede dejar costras y reducir vida útil del boiler.",business:"En negocios puede elevar mantenimiento en equipos de servicio."},
    MXSIN:{name:"Sinaloa",ppm:200,level:"mid",badge:"Agua media",desc:"Dureza media que puede variar por municipio. Un sistema preventivo de entrada es recomendable.",home:"En hogar puede dejar manchas y residuos moderados.",business:"En negocios puede aumentar el mantenimiento de lavabos y equipos con agua caliente."},
    MXSON:{name:"Sonora",ppm:305,level:"extreme",badge:"Agua muy dura",desc:"Estado árido con agua muy dura. Las incrustaciones son frecuentes en todos los equipos.",home:"En casa puede provocar mucho sarro y menor vida útil de electrodomésticos.",business:"En negocios incrementa el gasto técnico y la atención a instalaciones."},
    MXTAB:{name:"Tabasco",ppm:115,level:"low",badge:"Agua media",desc:"Agua generalmente blanda por la alta pluviosidad. El enfoque debe ser en sedimentos y microorganismos.",home:"En casa el sarro suele ser bajo.",business:"En negocios conviene priorizar filtración sanitaria y de sedimentos."},
    MXTAM:{name:"Tamaulipas",ppm:275,level:"high",badge:"Agua dura",desc:"Dureza alta en las zonas norte y centro. Un sistema antisarro reduce incrustaciones en regaderas y boilers.",home:"En vivienda puede aumentar el desgaste en boiler y grifería.",business:"En negocios puede elevar el mantenimiento de instalaciones de agua."},
    MXTLA:{name:"Tlaxcala",ppm:205,level:"mid",badge:"Agua media",desc:"Dureza media con potencial de manchas. Un filtro preventivo es suficiente para la mayoría de hogares.",home:"En casa puede dejar residuos moderados en baño y cocina.",business:"En negocios puede afectar limpieza y mantenimiento de equipos con agua caliente."},
    MXVER:{name:"Veracruz",ppm:130,level:"low",badge:"Agua media",desc:"Con dureza baja, el sarro es menos problemático. Se recomienda un filtro de sedimentos.",home:"En hogar el impacto por sarro es menor, pero conviene cuidar sedimentos.",business:"En negocios la prioridad suele ser filtración y claridad del agua."},
    MXYUC:{name:"Yucatán",ppm:360,level:"extreme",badge:"Agua muy dura",desc:"Con niveles muy altos de dureza, se debe atacar el problema desde la entrada del agua.",home:"En casa puede formar sarro muy rápido en todo el sistema.",business:"En negocios y hotelería el mantenimiento es constante por incrustaciones."},
    MXZAC:{name:"Zacatecas",ppm:255,level:"high",badge:"Agua dura",desc:"Dureza alta del altiplano. Un sistema antisarro es la inversión más efectiva.",home:"En hogar puede dañar tuberías y reducir vida útil del boiler.",business:"En negocios puede elevar mantenimiento y costos de operación."}
  };

  // ✅ FIX: Verde -> Amarillo. "low" usa los mismos colores que "mid"
  var levelColor = {
    low:    '#fde68a',  // amarillo (era verde)
    mid:    '#fde68a',  // amarillo
    high:   '#fca5a5',  // rojo claro
    extreme:'#f87171'   // rojo fuerte
  };

  document.addEventListener('DOMContentLoaded', function () {
    var mapStage = document.getElementById('mapStage');
    if (!mapStage) return;

    var placeholder    = document.getElementById('placeholder');
    var stateInfo     = document.getElementById('stateInfo');
    var stateName     = document.getElementById('stateName');
    var stateBadge    = document.getElementById('stateBadge');
    var statePpm      = document.getElementById('statePpm');
    var ppmBar        = document.getElementById('ppmBar');
    var stateDesc     = document.getElementById('stateDesc');
    var stateHome     = document.getElementById('stateHome');
    var stateBusiness = document.getElementById('stateBusiness');
    var stateProduct  = document.getElementById('stateProduct');
    var resetBtn      = document.getElementById('resetBtn');
    var zoomInBtn     = document.getElementById('zoomIn');
    var zoomOutBtn    = document.getElementById('zoomOut');
    var resetMapBtn   = document.getElementById('resetMap');
    var mapTooltip    = document.getElementById('mapTooltip');

    var vx = 0, vy = 0, vw = 1000, vh = 630;
    var isPanning = false, hasMoved = false;
    var startMouseX, startMouseY, startVX, startVY;
    var svgEl = null;
    var selectedId = null;
    var animReq;
    var persistentLabel = null;
    var lastTapTime = 0;

    function clampView() {
      var MAX_VW = 1000, MIN_VW = 200;
      if (vw > MAX_VW) vw = MAX_VW;
      if (vw < MIN_VW) vw = MIN_VW;
      vh = vw * 0.63;
      if (vx < 0) vx = 0;
      if (vy < 0) vy = 0;
      if (vx + vw > MAX_VW) vx = MAX_VW - vw;
      if (vy + vh > 630) vy = 630 - vh;
    }
    function applyView() {
      clampView();
      if (svgEl) svgEl.setAttribute('viewBox', vx + ' ' + vy + ' ' + vw + ' ' + vh);
    }
    function animateViewBox(targetVX, targetVY, targetVW, targetVH, duration) {
      cancelAnimationFrame(animReq);
      if (targetVW > 1000) targetVW = 1000;
      if (targetVW < 200) targetVW = 200;
      targetVH = targetVW * 0.63;
      if (targetVX < 0) targetVX = 0;
      if (targetVY < 0) targetVY = 0;
      if (targetVX + targetVW > 1000) targetVX = 1000 - targetVW;
      if (targetVY + targetVH > 630) targetVY = 630 - targetVH;
      var startVX = vx, startVY = vy, startVW = vw, startVH = vh;
      var startTime = performance.now();
      function step(now) {
        var p = (now - startTime) / duration;
        if (p > 1) p = 1;
        var ease = 1 - Math.pow(1 - p, 3);
        vx = startVX + (targetVX - startVX) * ease;
        vy = startVY + (targetVY - startVY) * ease;
        vw = startVW + (targetVW - startVW) * ease;
        vh = startVH + (targetVH - startVH) * ease;
        applyView();
        if (p < 1) animReq = requestAnimationFrame(step);
      }
      animReq = requestAnimationFrame(step);
    }
    function updatePersistentLabel(name, bbox) {
      if (!persistentLabel) {
        persistentLabel = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        persistentLabel.setAttribute('font-size', window.innerWidth < 480 ? '15px' : '18px');
        persistentLabel.setAttribute('font-family', 'system-ui, sans-serif');
        persistentLabel.setAttribute('font-weight', '800');
        persistentLabel.setAttribute('text-anchor', 'middle');
        persistentLabel.setAttribute('dominant-baseline', 'middle');
        persistentLabel.setAttribute('paint-order', 'stroke');
        persistentLabel.setAttribute('stroke', '#ffffff');
        persistentLabel.setAttribute('stroke-width', '4');
        persistentLabel.setAttribute('stroke-linecap', 'round');
        persistentLabel.setAttribute('stroke-linejoin', 'round');
        persistentLabel.setAttribute('fill', '#1e3a8a');
        persistentLabel.style.pointerEvents = 'none';
        svgEl.appendChild(persistentLabel);
      }
      persistentLabel.textContent = name;
      persistentLabel.setAttribute('x', bbox.x + bbox.width / 2);
      persistentLabel.setAttribute('y', bbox.y + bbox.height / 2);
      persistentLabel.style.display = 'block';
      svgEl.appendChild(persistentLabel);
    }
    function hidePersistentLabel() { if (persistentLabel) persistentLabel.style.display = 'none'; }
    function showState(id) {
      var d = stateData[id];
      if (!d) return;
      stateName.textContent = d.name;
      stateBadge.textContent = d.badge;
      stateBadge.className = 'badge badge-' + d.level;
      statePpm.textContent = d.ppm;
      stateDesc.textContent = d.desc;
      stateHome.textContent = d.home;
      stateBusiness.textContent = d.business;
      stateProduct.textContent = 'Barra Antisarro Aquamag, recomendada para ayudar a disminuir la acumulación de sarro y proteger instalaciones, equipos y tuberías.';
      var pct = Math.min(100, Math.round((d.ppm / 400) * 100));
      ppmBar.style.width = pct + '%';
      ppmBar.style.background = levelColor[d.level] || '#fde68a';
      placeholder.style.display = 'none';
      stateInfo.style.display = 'block';
    }
    function clearSelection() {
      selectedId = null;
      placeholder.style.display = 'flex';
      stateInfo.style.display = 'none';
      hidePersistentLabel();
      animateViewBox(0, 0, 1000, 630, 450);
      if (svgEl) {
        var paths = svgEl.querySelectorAll('path[id]');
        for (var i = 0; i < paths.length; i++) {
          var pid = paths[i].id;
          var d = stateData[pid];
          paths[i].setAttribute('fill', d ? levelColor[d.level] : '#fde68a');
          paths[i].style.filter = '';
        }
      }
    }
    function selectState(id) {
      if (!svgEl) return;
      if (selectedId) {
        var prev = svgEl.querySelector('#' + selectedId);
        if (prev) {
          var pd = stateData[selectedId];
          prev.setAttribute('fill', pd ? levelColor[pd.level] : '#fde68a');
          prev.style.filter = '';
        }
      }
      selectedId = id;
      var el = svgEl.querySelector('#' + id);
      var d = stateData[id];
      if (el && d) {
        el.setAttribute('fill', '#1e3a8a');
        el.style.filter = 'drop-shadow(0 0 6px rgba(30,58,138,0.7))';
        var bbox = el.getBBox();
        var targetVW = Math.max(200, bbox.width * 2.8);
        var targetVH = targetVW * 0.63;
        var targetVX = bbox.x + bbox.width/2 - targetVW/2;
        var targetVY = bbox.y + bbox.height/2 - targetVH/2;
        animateViewBox(targetVX, targetVY, targetVW, targetVH, 550);
        updatePersistentLabel(d.name, bbox);
      }
      showState(id);
    }
    function handleStateTap(pid) {
      if (!stateData[pid]) return;
      if (pid === selectedId) clearSelection();
      else selectState(pid);
    }
    function wireSvg(svg) {
      svgEl = svg;
      svg.setAttribute('viewBox', '0 0 1000 630');
      svg.setAttribute('width', '100%');
      svg.setAttribute('height', '100%');
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      svg.style.display = 'block';
      svg.style.width = '100%';
      svg.style.height = '100%';
      svg.style.position = 'absolute';
      svg.style.top = '0';
      svg.style.left = '0';
      var paths = svg.querySelectorAll('path[id]');
      for (var i = 0; i < paths.length; i++) {
        var pid = paths[i].id;
        var d = stateData[pid];
        paths[i].setAttribute('fill', d ? levelColor[d.level] : '#fde68a');
        paths[i].setAttribute('stroke', '#fff');
        paths[i].setAttribute('stroke-width', '0.8');
        paths[i].style.cursor = 'pointer';
        paths[i].style.transition = 'fill 0.18s';
      }
      mapStage.addEventListener('mousemove', function(ev) {
        if (isPanning || hasMoved) { mapTooltip.classList.remove('show'); return; }
        var t = ev.target;
        if (t && t.tagName.toLowerCase() === 'path' && stateData[t.id]) {
          mapTooltip.textContent = stateData[t.id].name;
          mapTooltip.style.left = ev.clientX + 'px';
          mapTooltip.style.top = (ev.clientY - 15) + 'px';
          mapTooltip.classList.add('show');
        } else {
          mapTooltip.classList.remove('show');
        }
      });
      mapStage.addEventListener('mouseover', function(ev) {
        var t = ev.target;
        if (!t || t.tagName.toLowerCase() !== 'path') return;
        var pid = t.id;
        if (!stateData[pid]) return;
        if (pid === selectedId) return;
        t.style.filter = 'brightness(0.82)';
      });
      mapStage.addEventListener('mouseout', function(ev) {
        mapTooltip.classList.remove('show');
        var t = ev.target;
        if (!t || t.tagName.toLowerCase() !== 'path') return;
        var pid = t.id;
        if (pid === selectedId) return;
        t.style.filter = '';
      });
      mapStage.addEventListener('click', function(ev) {
        if (hasMoved) return;
        var now = Date.now();
        if (now - lastTapTime < 350) return;
        lastTapTime = now;
        var t = ev.target;
        if (!t || t.tagName.toLowerCase() !== 'path') return;
        var pid = t.id;
        handleStateTap(pid);
      });
    }

    var svgUrl = (typeof window.AQUAMAG_SVG_URL === 'string' && window.AQUAMAG_SVG_URL)
      ? window.AQUAMAG_SVG_URL
      : 'mx.svg';

    fetch(svgUrl, { credentials: 'omit', cache: 'no-cache' })
      .then(function(r) {
        if (!r.ok) throw new Error('SVG load error: ' + r.status + ' (' + r.statusText + ')');
        return r.text();
      })
      .then(function(txt) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(txt, 'image/svg+xml');
        var svg = doc.querySelector('svg');
        if (!svg) throw new Error('No SVG element found in response');
        while (mapStage.firstChild) mapStage.removeChild(mapStage.firstChild);
        mapStage.appendChild(svg);
        wireSvg(svg);
        applyView();
        setTimeout(applyView, 0);
      })
      .catch(function(err) {
        mapStage.innerHTML =
          '<div style="padding:2rem;color:#ef4444;text-align:center;font-family:sans-serif;">' +
          'No se pudo cargar el mapa (mx.svg): ' + (err && err.message ? err.message : err) +
          '</div>';
        if (window.console && console.error) console.error('[AQUAMAG]', err);
      });

    mapStage.addEventListener('wheel', function(ev) {
      ev.preventDefault();
      if (!svgEl) return;
      cancelAnimationFrame(animReq);
      var rect = svgEl.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var mx = (ev.clientX - rect.left) / rect.width;
      var my = (ev.clientY - rect.top) / rect.height;
      var factor = ev.deltaY < 0 ? 0.85 : 1.18;
      var newW = vw * factor;
      var newH = vh * factor;
      vx = vx + mx * (vw - newW);
      vy = vy + my * (vh - newH);
      vw = newW;
      vh = newH;
      applyView();
    }, { passive: false });

    mapStage.addEventListener('mousedown', function(ev) {
      cancelAnimationFrame(animReq);
      if (ev.button !== 0 || !svgEl) return;
      isPanning = true;
      hasMoved = false;
      startMouseX = ev.clientX;
      startMouseY = ev.clientY;
      startVX = vx;
      startVY = vy;
      mapStage.style.cursor = 'grabbing';
    });
    window.addEventListener('mousemove', function(ev) {
      if (!isPanning || !svgEl) return;
      var rect = svgEl.getBoundingClientRect();
      var dx = (ev.clientX - startMouseX) / rect.width * vw;
      var dy = (ev.clientY - startMouseY) / rect.height * vh;
      if (Math.abs(dx) > 2 || Math.abs(dy) > 2) hasMoved = true;
      vx = startVX - dx;
      vy = startVY - dy;
      applyView();
    });
    window.addEventListener('mouseup', function() {
      isPanning = false;
      mapStage.style.cursor = 'grab';
      setTimeout(function() { hasMoved = false; }, 50);
    });

    var touchStartX, touchStartY, touchStartVX, touchStartVY;
    var pinchStartDist = 0, pinchStartVW, pinchStartVH, pinchStartVX, pinchStartVY;
    function getTouchDist(t) {
      var dx = t[0].clientX - t[1].clientX;
      var dy = t[0].clientY - t[1].clientY;
      return Math.sqrt(dx*dx + dy*dy);
    }
    mapStage.addEventListener('touchstart', function(ev) {
      cancelAnimationFrame(animReq);
      if (!svgEl) return;
      hasMoved = false;
      if (ev.touches.length === 1) {
        isPanning = true;
        touchStartX = ev.touches[0].clientX;
        touchStartY = ev.touches[0].clientY;
        touchStartVX = vx;
        touchStartVY = vy;
      } else if (ev.touches.length === 2) {
        isPanning = false;
        pinchStartDist = getTouchDist(ev.touches);
        pinchStartVW = vw; pinchStartVH = vh;
        pinchStartVX = vx; pinchStartVY = vy;
      }
    }, { passive: false });
    mapStage.addEventListener('touchmove', function(ev) {
      if (!svgEl) return;
      ev.preventDefault();
      if (ev.touches.length === 1 && isPanning) {
        var rect = svgEl.getBoundingClientRect();
        var dx = (ev.touches[0].clientX - touchStartX) / rect.width * vw;
        var dy = (ev.touches[0].clientY - touchStartY) / rect.height * vh;
        if (Math.abs(dx) > 3 || Math.abs(dy) > 3) hasMoved = true;
        vx = touchStartVX - dx;
        vy = touchStartVY - dy;
        applyView();
      } else if (ev.touches.length === 2) {
        hasMoved = true;
        var dist = getTouchDist(ev.touches);
        var factor = pinchStartDist / dist;
        var cx = pinchStartVX + pinchStartVW / 2;
        var cy = pinchStartVY + pinchStartVH / 2;
        vw = pinchStartVW * factor;
        vh = pinchStartVH * factor;
        vx = cx - vw / 2;
        vy = cy - vh / 2;
        applyView();
      }
    }, { passive: false });
    mapStage.addEventListener('touchend', function(ev) {
      isPanning = false;
      if (!hasMoved && ev.changedTouches.length === 1) {
        var now = Date.now();
        if (now - lastTapTime < 350) {
          setTimeout(function() { hasMoved = false; }, 50);
          return;
        }
        lastTapTime = now;
        var touch = ev.changedTouches[0];
        var el = document.elementFromPoint(touch.clientX, touch.clientY);
        if (el && el.tagName.toLowerCase() === 'path') {
          var pid = el.id;
          handleStateTap(pid);
        } else {
          clearSelection();
        }
      }
      setTimeout(function() { hasMoved = false; }, 50);
    }, { passive: true });

    if (zoomInBtn) {
      zoomInBtn.addEventListener('click', function() {
        var cx = vx + vw / 2;
        var cy = vy + vh / 2;
        var targetVW = vw * 0.6;
        var targetVH = targetVW * 0.63;
        animateViewBox(cx - targetVW / 2, cy - targetVH / 2, targetVW, targetVH, 250);
      });
    }
    if (zoomOutBtn) {
      zoomOutBtn.addEventListener('click', function() {
        var cx = vx + vw / 2;
        var cy = vy + vh / 2;
        var targetVW = vw * 1.5;
        var targetVH = targetVW * 0.63;
        animateViewBox(cx - targetVW / 2, cy - targetVH / 2, targetVW, targetVH, 250);
      });
    }
    if (resetMapBtn) resetMapBtn.addEventListener('click', clearSelection);
    window.addEventListener('resize', function() { if (svgEl) applyView(); });

    // ✅ FIX: El botón "BARRA ANTISARRO AQUAMAG" navega a la URL del producto.
    //    Ya no hace falta preventDefault: dejamos que el <a href> funcione solo.
    //    Solo nos aseguramos de que NO abra en pestaña nueva y que la URL sea válida.
    if (resetBtn) {
      // Eliminar cualquier target="_blank" heredado
      resetBtn.removeAttribute('target');

      // Forzar que no tenga rel="noopener" raro (es seguro en mismo dominio)
      resetBtn.removeAttribute('rel');

      // Verificar que tenga un href válido; si no, usar el CTA inyectado por Liquid
      var href = resetBtn.getAttribute('href');
      if (!href || href === '#' || href === '#compra-aquamag') {
        if (window.AQUAMAG_CTA_URL) {
          resetBtn.setAttribute('href', window.AQUAMAG_CTA_URL);
        }
      }
    }
  });
})();